export default {
  form: {
    owner_phone_number: {
      label: 'Numărul de telefon al persoanei de contact',
      placeholder: '1785080120',
    },
    owner_email: {
      label: 'Emailul persoanei de contact',
      placeholder: 'Introduceți emailul',
    },
    owner_first_name: {
      label: 'Prenume',
      placeholder: 'Introduceți prenumele',
    },
    owner_last_name: {
      label: 'Nume de familie',
      placeholder: 'Introduceți numele de familie',
    },
    owner_dob: {
      label: 'Data nașterii',
      placeholder: 'Dată',
    },
    owner_id_number: {
      label: 'Număr de identificare (ex. număr de asigurări sociale în SUA)',
      placeholder: '123456789',
    },
  },
  buttons: {
    back: 'Înapoi',
    next: 'Următor',
  },
};
